console.log('✅ home-page-trending-listings.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentBasicListingCard } from '../cards/basic-listing-card.js';
import { convertStringAmountToCurrencyAndSignDirectionForLanguage } from '../../js/utils-convert-currency.js';

import { convertNumberStringFromUKFormatToAnyLanguageFormatDouble } from '../../js/utils-convert-numbers.js';

import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';

import { LRUCacheWithTTL } from '../../js/utils-cache.js';
import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

//const lang = appState.SiteLanguageCookie;

//const generalPageSpecificCache = new LRUCacheWithTTL(10, 15 * 60 * 1000); // 10 entries, 15‑minute TTL
// const key = JSON.stringify(searchPageComponentSharedState.searchRequestModel);
//if (generalPageSpecificCache.has(storageKey)) {

//   alert("Using cached data");
//   console.log("🌐 Fetched All listings from cache");
//    const cachedData = generalPageSpecificCache.get(storageKey);
//    return cachedData;
//}
//generalPageSpecificCache.set(storageKey, trendinglistings);

export async function buildComponentHomePageTrendingListings() {
  console.log(
    `🔄 Building Component: HomePageTrendingListings - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    // ✅ Fetch all translations in parallel

    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);
    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const { keyTrending: textkeyTrending, keyProducts: textkeyProducts } = _tempTextTranslator;

    const trendinglistingsHtml = await renderTrendinglistingsHtmlStatic();

    // Build the trending listings HTML
    const html = `
            <center>
                <div id="HomePageDivTrendingListingTitle" class="TrendingDiv">
                    <h2>${textkeyTrending} <b>${textkeyProducts}</b></h2>
                </div>
                 <br />
            
                <div id="trendingListngListContainer" class="listngListContainer">
                    ${trendinglistingsHtml}
                </div>
            </center>
            <br />             
        `;

    console.log('✅ HomePageTrendingListings built successfully.');

    // Register event listeners
    //  registerEventListenerToAttach(attachEventListenersHomePageTrendingListings);
    registerEventListenerToAttach(async () => attachEventListenersHomePageTrendingListings());

    return html;
  } catch (err) {
    console.error('❌ Error building HomePageTrendingListings:', err);
    return '<div>Error loading trending listings</div>';
  }
}

async function renderTrendinglistingsHtmlStatic() {
  if (isNodeEnvironment()) {
    return await renderTrendinglistingsHtml();
  } else {
    return await renderLoadingData();
  }
}

async function renderLoadingData() {
  const countOfItems = 8; // Replace this with your actual value

  const listingCardPromises = [];

  for (let i = 0; i < countOfItems; i++) {
    const buyingCompanyID = '';
    const listingID = '';
    const skuid = '';
    const name = '';
    const builtLink = '';
    const image1FileName = '';
    const builtPrice = '';
    const abvSingle = '';
    const builtMOQ = '';
    const isProducer = '';
    const customerRating = '';
    const listingCardType = 'Lazy';

    listingCardPromises.push(
      buildComponentBasicListingCard(
        buyingCompanyID,
        listingID,
        skuid,
        name,
        builtLink,
        image1FileName,
        builtPrice,
        abvSingle,
        builtMOQ,
        isProducer,
        customerRating,
        listingCardType
      )
    );
  }

  const listingCards = await Promise.all(listingCardPromises);

  return listingCards.join('');
}

async function renderTrendinglistingsHtml() {
  console.log('🔄 Rendering trending listings HTML');

  const listings = await populateHomePageTrendinglistings();

  if (!listings || listings.length === 0) {
    return `<p>No trending listings available at the moment.</p>`;
  }

  const listngCards = await Promise.all(
    listings.map(async listing => {
      /*  buyingCompanyID, listingID, skuid, name, link, image1FileName, price, abvSingle, moq, isProducer, customerRating, listngCardType*/

      const buyingCompanyID = listing.buyingCompanyID;
      const listingID = listing.listingID;
      const skuid = listing.skuid;
      const name = listing.name;

      // Construct the link with the correct structure

      const builtLink = `/${appState.SiteLanguageCookie}/${listing.departmentID}/${listing.departmentSEOPageName}/${listing.categoryID}/${listing.categorySEOPageName}/${listing.productID}/${listing.productSEOPageName}/${listing.listingID}/${listing.skuid}/${listing.seoPageName}`;

      const image1FileName = listing.image1FileName;

      const builtPrice = convertStringAmountToCurrencyAndSignDirectionForLanguage(
        listing.price,
        appState.SiteLanguageCookie,
        appState.SiteCurrencySignSingleCookie,
        appState.SiteCurrencySignMultipleCookie,
        appState.SiteCurrencyRateCookie
      );

      const abvSingle = listing.unitOfMeasureABVSingle;

      const builtMOQ = convertNumberStringFromUKFormatToAnyLanguageFormatDouble(
        listing.moq,
        appState.SiteLanguageCookie
      );

      const isProducer = listing.isProducer;

      const customerRating = listing.customerRating;

      const listngCardType = 'Basic'; // Assuming Basic for now

      return await buildComponentBasicListingCard(
        buyingCompanyID,
        listingID,
        skuid,
        name,
        builtLink,
        image1FileName,
        builtPrice,
        abvSingle,
        builtMOQ,
        isProducer,
        customerRating,
        listngCardType
      );
    })
  );

  return listngCards.join('');
}

async function attachEventListenersHomePageTrendingListings() {
  try {
    console.log('✅ HomePageTrendingListings event listeners attached.');
    // Placeholder for future event listeners if needed

    //  alert("HomePageTrendingListings event listeners attached.");

    const trendingListngListContainer = document.getElementById('trendingListngListContainer');
    if (!trendingListngListContainer) {
      console.error("❌ Element with ID 'trendingListngListContainer' not found.");
      return;
    } else {
      let html = await renderTrendinglistingsHtml();
      trendingListngListContainer.innerHTML = html;
    }
  } catch (error) {
    console.error('❌ Error attaching event listeners to HomePageTrendingListings:', error);
  }
}

async function populateHomePageTrendinglistings() {
  console.log('✅ Populating Home Page Trending listings');

  const storageKey = `homePageTrendingListings_${appState.SiteLanguageCookie}`;

  // Try to load from localStorage first
  const cachedlistings = loadFromLocalStorage(storageKey);
  if (cachedlistings && Array.isArray(cachedlistings) && cachedlistings.length > 0) {
    console.log('✅ Loaded HomePageTrendinglistings from cache');
    //  console.log("Cached listings:", cachedlistings);
    return cachedlistings;
  }

  // Fetch from the server if not cached
  console.log('🌐 Fetching HomePageTrendinglistings from server');
  return await fetchHomePageTrendingListings(appState.SiteLanguageCookie);
}

async function fetchHomePageTrendingListings() {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Fetching trending listings from pre-built data');

      const data = await myFetchJsonContentFromBuildData('home-page-trending-listings.json');

      //console.log("Filtered Data:", data);

      if (data && data[appState.SiteLanguageCookie]) {
        const listings = data[appState.SiteLanguageCookie];
        console.log(
          `✅ Loaded trending listings for language '${appState.SiteLanguageCookie}' from pre-built data`
        );
        return listings;
      } else {
        console.warn(`⚠️ No trending listings found for language '${appState.SiteLanguageCookie}'`);
        return [];
      }
    } else {
      const storageKey = `homePageTrendingListings_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log('✅ Loaded trending listings from cache');
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetTrendingListingsHomePageAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch trending listings from server');

      const trendinglistings = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, trendinglistings);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched trending listings from the server');

      return trendinglistings;
    }
  } catch (error) {
    console.error('❌ Error fetching trending listings:', error);
    return [];
  }
}
